import React, { useContext, useState } from 'react';

import { Form, Modal } from 'antd';
import styled from 'styled-components';

import { EditDataModalContext } from './EditDataModalContext';
import EditDataModalFooter from './EditDataModalFooter';
import { CommunityInfoContext } from '../../CommunityInfoContext';

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 0px;
      line-height: 1;
      border-radius: 1px;
      user-select: none;
    }
    .ant-modal-body {
      display: flex;
      flex-direction: column;
      padding: 0px;
      line-height: normal;
    }
  }
`;

const Header = styled.div`
  padding: 16px 30px;
  border-bottom: 1px solid var(--line-gray);
`;

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
`;

const SubTitle = styled.div`
  font-size: 14px;
  font-family: var(--font-regular);
  color: var(--text-secondary);
`;

const Content = styled.div`
  position: relative;
  overflow-y: auto;
  height: 100%;
  display: flex;
`;

const CommunityNameContainer = styled.span`
  color: var(--dark-blue);
`;

interface Props {
  open: boolean;
  title: string;
  expanded?: boolean;
  communityName?: any;
  subtitle?: React.ReactNode;
  subtitleStyle?: React.CSSProperties;
  onClose: () => void;
  onSuccess: (data?: any) => void;
  children: React.ReactNode;
}

const EditDataModal = ({
  open,
  title,
  communityName,
  subtitle,
  subtitleStyle,
  children,
  onClose,
  onSuccess,
  expanded,
}: Props) => {
  const { communityInfo } = useContext(CommunityInfoContext);
  const [modified, setModified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    form.submit();
  };

  const hadnleSuccess = (data?: any) => {
    setLoading(false);
    onSuccess(data);
  };

  return (
    <StyledModal
      centered
      style={{
        padding: 0, // Ensure no extra padding from the Modal itself
      }}
      open={open}
      width={expanded ? window.innerWidth * 0.9 : 'fit-content'}
      footer={null}
      onCancel={handleCancel}
    >
      <Header>
        <Title>{title}</Title>
        <SubTitle style={subtitleStyle}>
          {subtitle ?? (
            <>
              for <CommunityNameContainer>{communityInfo?.comunity_name || communityName}</CommunityNameContainer>
            </>
          )}
        </SubTitle>
      </Header>
      <EditDataModalContext.Provider
        value={{ form, modified, loading, setModified, setLoading, onSuccess: hadnleSuccess }}
      >
        <Content style={{ maxHeight: window.innerHeight * 0.7 }} className={'mini-scroll'}>
          {children}
        </Content>
        <EditDataModalFooter onCancel={handleCancel} onSave={handleSave} />
      </EditDataModalContext.Provider>
    </StyledModal>
  );
};

export default EditDataModal;
